"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DropdownButton", {
    enumerable: true,
    get: function() {
        return DropdownButton;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _Dropdown = require("../Dropdown");
const _DropdownMenu = require("../DropdownMenu/DropdownMenu");
const _DropdownToggle = require("../DropdownToggle/DropdownToggle");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const DropdownButton = /*#__PURE__*/ _react.default.forwardRef((param, ref)=>{
    let { children, placement = "bottom-start", mobileView, onSelect, ...props } = param;
    return /*#__PURE__*/ _react.default.createElement(_Dropdown.Dropdown, {
        placement: placement,
        onSelect: onSelect,
        flip: true
    }, /*#__PURE__*/ _react.default.createElement(_DropdownToggle.DropdownToggle, {
        ...props,
        ref: ref
    }, props.title), /*#__PURE__*/ _react.default.createElement(_DropdownMenu.DropdownMenu, {
        title: props.title,
        mobileView: mobileView
    }, children));
});
DropdownButton.displayName = "DropdownButton";

//# sourceMappingURL=DropdownButton.js.map